import script from "./SideMenuClientFields.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideMenuClientFields.vue?vue&type=script&lang=ts&setup=true"

import "./SideMenuClientFields.vue?vue&type=style&index=0&id=28831b59&lang=scss"
import "./SideMenuClientFields.vue?vue&type=style&index=1&id=28831b59&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28831b59"]])

export default __exports__